// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5ad3ca2f","453":"0f22bb54","455":"0cd3e08f"}[chunkId] + ".chunk.js";
};